module.exports = __webpack_public_path__ + "img/eventstorming2.63ecdc03.png";